export default "__VITE_ASSET__BmSo9JeF__"